import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";
import clsx from "clsx";
import style from "./style.module.scss";

export const NavButtons = ({ onClickLeft, onClickRight, className }) => {
  return (
    <div className={clsx(style.navBtns, className)}>
      <div className={style.btn} onClick={onClickRight}>
        <ArrowForwardIcon />
      </div>

      <div className={style.btn} onClick={onClickLeft}>
        <ArrowBackIcon />
      </div>
    </div>
  );
};

export default NavButtons;
